<!-- App.vue -->
<template>
  <div id="appH">
    <router-view :isPopShow="changePop"/>
    <callWe v-if="isPop" :closePop="changePop"></callWe>
  </div>
</template>


<script>
import callWe from "./components/callWe.vue"
export default {
  name: 'App',
  data(){
    return{
      isPop:false
    }
  },
  components: {
    callWe
  },
  methods:{
    changePop(ip){
      this.isPop = ip;
    }
  }
}
</script>

<style>
#appH {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  margin: auto;
}
</style>
